import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hub-input',
  templateUrl: './hub-input.component.html',
  styleUrls: ['./hub-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HubInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => HubInputComponent),
      multi: true,
    },
  ],
})
export class HubInputComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() type?: string = 'text';
  @Input() autofocus?: boolean = false;
  @Input() icon: string = '';
  @Input() iconColor?: string = '';
  @Input() isDisabled?: boolean = false
  @Input() allowClear?: boolean = false;
  @Input() labelColor?: string = '';
  @Input() required?: boolean = false;
  @Input() rounded?: boolean = false;
  @Input() maxLength?: number = 100000;
  @Input() errorLabel?: string = this.translate.instant('general.error.field_is_required');
  @Output() input = new EventEmitter<Event>(); // Add this output

  value: any | null = null;

  @ViewChild('inputRef') inputElement!: ElementRef;

  constructor(
    private cdr: ChangeDetectorRef,
    private translate : TranslateService
  ) { }

  ngAfterViewInit() {
    if (this.autofocus) {
      setTimeout(() => {
        this.inputElement.nativeElement.focus();
      });
    }
  }


  onChange = (value: any) => { };
  onTouched = () => { };

  writeValue(value: string | null): void {
    this.value = value;
  }


  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: FormControl): ValidationErrors | null {
    return control.errors;
  }

  handleInputChange(event: any) {
    if (this.isDisabled) {
      return; // Do not update value if input is disabled
    }
    if (this.type == 'number') {
      this.value = +event.target.value;
    } else {
      this.value = event.target.value;
    }
    this.onChange(this.value); // 🔥 This triggers ngModelChange
    this.cdr.detectChanges(); // Trigger change detection
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  clearInput(): void {
    this.value = '';
    this.onChange(this.value);
    this.onTouched(); // Mark as touched
    this.input.emit();
  }

  focusInput(): void {
    if (this.inputElement) {
      this.inputElement.nativeElement.focus();
    }
  }
}
